import React, { ReactNode } from "react";
import Text from "@/components/marketing/Text";
import Section from "@/components/marketing/Section";

interface CustomerQuoteProps {
    children: ReactNode;
    image?: string;
    name?: string;
    position?: string;
};

const CustomerQuote: React.FC<CustomerQuoteProps> = ({
    children,
    image = '',
    name = '',
    position = '',
}) => {
    return (
        <Section contentWidth="content-xs" padding="p-none" className="mx-auto my-6 border-y border-dashed border-silvermist-100">
            <Section contentWidth="content-xxs" className="flex flex-col items-center gap-6">
                <div className="w-16 h-16 overflow-hidden rounded-full">
                    <img
                        src={image}
                        alt={`Portrait of ${name}`}
                        className="w-full h-full object-cover"
                    />
                </div>
                <Text as="blockquote" size="xl" align="center" tracking="tight" color="primary">{children}</Text>
                <Text align="center">
                    <Text as="span" weight="semibold" color="primary" className="inline before:inline after:inline">{name}</Text>, {position}
                </Text>
            </Section>
        </Section>
    );
};

export default CustomerQuote;